import { ReactNode } from 'react';

import { Divider } from '~/components/atoms/Divider';

import styles from './AuthViewHeadline.module.scss';

type TAuthViewHeadlineProps = {
  headline: string;
  subHeadline: ReactNode;
};

export function AuthViewHeadline({
  headline,
  subHeadline,
}: TAuthViewHeadlineProps): JSX.Element {
  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>{headline}</h2>
      <p className={styles.text}>{subHeadline}</p>
      <Divider className={styles.divider} />
    </div>
  );
}
